var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('footer',{staticClass:"pt-5 my-5 text-muted border-top"},[_vm._v(" Resto Line team · © 2022 ")])}
var staticRenderFns = []

export { render, staticRenderFns }